module.exports = __webpack_public_path__ + "img/g_mro_14.53a5691a.png";